module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("sitepage_liveshow", [["div",{"class":"pad-lr pad-tb content-page"},[["div",{"id":"liveshow-banner-container","class":"liveshow-banner-container"}],["div",{"id":"flash-player-liveshow"}],["div",{"class":"content-report"}],["div",{"id":"conversation"}],["div",{"id":"recorded-liveshows","class":"recorded-liveshows "}],["div",{"id":"join-banner"}]]],["div",{"id":"newsletter-container"}],["div",{"class":"join-banner-wrpper"}]]);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-dynamic-injection!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-template-loader?interpolate!./templates/sitepage/liveshow.tpl
// module id = 1232
// module chunks = 4